export default function( id, onInit, onEnd ) {
    const closeBtn = document.getElementById(id+'-close')
    const pauseBtn = document.getElementById(id+'-pause')

    if ( !closeBtn || !pauseBtn ) return;

    document.getElementById(id).classList.add('is-playing')
    document.getElementById(id+'-video').play()
    
    new Array(closeBtn, pauseBtn).forEach(el => el.addEventListener('keydown', e => {
        
        if ( e.key === 'Tab' && e.target === closeBtn ) {
            e.preventDefault()
            pauseBtn.focus()
            return
        } 
        else if ( e.key === 'Tab' && e.target === pauseBtn ) {
            e.preventDefault()
            closeBtn.focus()
        }
        
    }))

    document.getElementById(id+'-video').addEventListener('ended', () => {
        document.getElementById(id).classList.remove('is-playing')
        
        if (onEnd instanceof Function) onEnd()
    }, {
        once: true
    })

    document.getElementById(id+'-close').addEventListener('click', () => {
        document.getElementById(id).classList.remove('is-playing')

        if (onEnd instanceof Function) onEnd()
    }, {
        once: true
    })

    if (onInit instanceof Function) onInit()

    closeBtn.focus()
}